module.exports = __webpack_public_path__ + "static/media/black-star.d945356b.svg";